import * as actions from './preferences/actions'
import * as mutations from './preferences/mutations'
import * as getters from './preferences/getters'

import { dataProps } from './preferences/properties'

const state = {
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/preferences.js